import { DASHBOARD_VIEW_TYPE } from '@adtrackify/at-tracking-event-types';

export const dashboardKeys = {
  all: ['dashboard'] as const,
  pages: {
    all: () => [...dashboardKeys.all, 'pages'] as const,
    list: (pixelId: string) => [...dashboardKeys.pages.all(), pixelId] as const,
    detail: (dashboardPageId: string) =>
      [...dashboardKeys.pages.all(), 'detail', dashboardPageId] as const,
  },
  views: {
    all: () => [...dashboardKeys.all, 'views'] as const,
    list: (pixelId: string, type: DASHBOARD_VIEW_TYPE = DASHBOARD_VIEW_TYPE.VIEW) =>
      [...dashboardKeys.views.all(), pixelId, type] as const,
  },
  view: (viewId: string, type?: string) =>
    (type
      ? ([...dashboardKeys.all, 'view', viewId, type] as const)
      : ([...dashboardKeys.all, 'view', viewId] as const)),
};
